// css =>
import "../../BaseStructure.css";
import Styled from "./plant-box.module.css";

// context =>
import { useTheme } from '../../context/theme-context';

const PlantBox = (props) => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div
            className={`col-2 ${ Styled.PlantBox } `}>
            <div className="col-12">
                <img src={ props.plantPicture } alt={ props.plantTittle } loading="lazy" />
            </div>

            <p
                style={{
                    color: theme === "day" ? "#000000" : ""
                }}
            >{ props.plantTittle }</p>
        </div>
    );
}

export default PlantBox;
